var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.145 6.896c3.819 5.468 3.819 12.74 0 18.208l-4.129-4.131c1.713-3.093 1.713-6.853 0-9.947zM25.104 2.855l-4.131 4.129c-3.187-1.749-7.056-1.692-10.187 0.161-3.131 1.849-5.047 5.215-5.047 8.849 0 3.636 1.916 7 5.047 8.849s7 1.905 10.187 0.156l4.131 4.145c-4.891 3.391-11.26 3.781-16.531 1.021s-8.579-8.224-8.579-14.172c0-5.953 3.308-11.411 8.579-14.177 5.271-2.76 11.64-2.364 16.531 1.021zM29.145 6.896c3.819 5.468 3.819 12.74 0 18.208l-4.129-4.131c1.713-3.093 1.713-6.853 0-9.947z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOc);
export default __webpack_public_path__ + "static/media/oc.8cb12c18c6a2e6113c8f2bc4bf9d9e76.svg";
export { ForwardRef as ReactComponent };